var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2010,
    height: 2010,
    viewBox: "0 0 2010 2010",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_968_137",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2010,
    height: 2010
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2010,
    height: 2010,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_968_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1724.36 239.714L1574.2 85.2104C1501.2 10.249 1378.57 16.9123 1314.34 99.3698L880.542 657.416L565.206 253.874C499.302 169.75 366.66 187.241 325.366 286.357L250.286 466.264C227.345 521.236 234.436 584.12 269.056 632.429L576.885 1063.46L304.928 1428.27C264.468 1482.41 262.382 1555.7 298.671 1612.34L380.425 1738.53C439.655 1829.73 570.211 1837.64 639.868 1754.77L875.536 1474.08L1196.71 1907.19C1247.18 1975.07 1339.78 1996.73 1414.86 1957.58L1584.21 1869.71C1680.14 1819.73 1706.84 1694.8 1639.69 1610.26L1217.99 1077.62L1732.28 470.429C1789.43 402.964 1786.09 303.015 1724.36 239.714ZM1658.46 407.961L1104.11 1062.21C1097.44 1070.12 1097.44 1081.36 1103.7 1089.28L1563.77 1669.81C1592.97 1706.88 1581.29 1761.43 1539.58 1783.5L1370.23 1871.37C1337.28 1888.45 1296.82 1879.29 1274.71 1849.3L896.809 1339.56C888.467 1328.32 871.782 1327.9 863.023 1338.73L566.04 1692.72C538.093 1726.03 485.954 1722.7 462.179 1686.47L380.425 1560.28C365.826 1537.8 366.66 1508.23 382.928 1486.57L687.836 1077.62C693.259 1070.12 693.676 1060.13 688.253 1052.21L348.724 576.624C333.708 555.385 330.372 527.899 340.382 504.161L415.462 324.254C427.976 293.853 468.853 288.439 489.291 314.259L863.857 793.179C872.617 804.424 889.301 804.424 898.061 793.179L1391.09 158.506C1419.03 122.275 1472.84 119.36 1504.96 152.259L1655.12 306.763C1681.81 334.665 1683.48 378.393 1658.46 407.961Z",
    fill: "#00E599"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a244c7cb52fc0eb4807ea29a888d7e74.svg";
export { ForwardRef as ReactComponent };